// link-component.tsx
// (c) NCR Voyix Corporation 2025. All rights reserved.

import React from 'react'
import { Link } from 'react-router-dom'
import { createLinkComponent } from '@ncr-design-system/pattern-utils'

export const linkComponent = createLinkComponent<HTMLAnchorElement>(
  (props, ref) => <Link {...props} to={props.href} ref={ref} />
) // type = 'a'
